'use client';
import {useTranslations} from 'next-intl';
import {controlModal} from '@/libs/jquery.util';
import {Link} from "@/i18n/routing";

export default function ProductDetailsBrand({ isModal, brand }) {
  const t = useTranslations('catalog');
  
  return (
      <li
          onClick={() => {
            isModal ? controlModal() : "";
          }}
      >
        <strong>{t('brand')}:</strong>
        <span>
          <Link href={`/catalog?brand=${brand.alt}&title=${brand.title}`}>
            {brand.title}
          </Link>
        </span>
      </li>
  );
};
